module.exports = __webpack_public_path__ + "static/media/006_AI_carepanel.ec34e591.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp_org/006_AI_carepanel.png
// module id = 542
// module chunks = 0